import { Injectable } from '@angular/core';

import { TModuleInfo } from '@modweb5/interfaces/modules.interface';


@Injectable({
	providedIn: 'root'
})
export class ModuleListService {

	private moduleListArray: Array<TModuleInfo>;
	private moduleListMap: Map<string, TModuleInfo> = new Map();
	private importedModules: any;

	constructor(
	) {
	}

	//-----------------------------------------------------------------------------------------------
	public setListOfImportedModules(aImportedModules: any): void {
		this.importedModules = aImportedModules;
	}

	//-----------------------------------------------------------------------------------------------
	public getListOfImportedModules(): any {
		return this.importedModules;
	}


	//-----------------------------------------------------------------------------------------------
	public setModuleListMap(aModuleListMap: Map<string, TModuleInfo>): void {

		this.moduleListMap = aModuleListMap;

		this.setModuleListArray();
	}

	//-----------------------------------------------------------------------------------------------
	private setModuleListArray(): void {
		this.moduleListArray = [];
		this.moduleListMap.forEach(moduleInfo => {
			this.moduleListArray.push(moduleInfo);
		});
		this.moduleListArray.sort((objPrev, objNext) => {
			return this.sortingModuleListArray(objPrev, objNext);
		});
	}

	//-----------------------------------------------------------------------------------------------
	sortingModuleListArray(objPrev: any, objNext: any): number {
	//-----------------------------------------------------------------------------------------------
		
		let result;
		if (objPrev.order < objNext.order) {
			result = -1;
		} else if (objPrev.id > objNext.id) {
			result = 1;
		}
		return result;
	}

	//-----------------------------------------------------------------------------------------------
	getModuleListArray(): Array<TModuleInfo> {
		return JSON.parse(JSON.stringify(this.moduleListArray));
	}

	//-----------------------------------------------------------------------------------------------
	getModuleInfo(aModuleId: string): TModuleInfo {
		return JSON.parse(JSON.stringify(this.moduleListMap.get(aModuleId)));
	}

	//-----------------------------------------------------------------------------------------------
	getModuleMapList(): Map<string, TModuleInfo> {
		return this.moduleListMap;
	}

}
